function t(n) {
  return function() {
    return n;
  };
}
export {
  t as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/constant.js
// module id = 1515
// module chunks = 41